import * as actionTypes from './actionTypes';

interface State {
  data: any;
  isFetching: boolean;
  error: boolean;
}

const initialState: State = {
  data: {},
  isFetching: false,
  error: false
}

export const validateAccess = (state: State = initialState, action) => {
  switch(action.type) {
    case actionTypes.FETCH_VALIDATE_ACCESS_REQUEST:
      return {
        ...state,
        isFetching: true
      }
    case actionTypes.FETCH_VALIDATE_ACCESS_FAILURE:
      return {
        ...state,
        isFetching: false,
        error: true
      }
    case actionTypes.FETCH_VALIDATE_ACCESS_SUCCESS:
      return {
        ...state,
        isFetching: false,
        error: false,
        data: action.data
      }
    case actionTypes.CLEAR_VALIDATE_ACCESS_DATA:
      return {
        ...state,
        data: {}
      }
    default:
      return state;
  }
}
